import { Body, FormatUtils, Heading3, useLocales } from "@/lib/main";
import { DonutChartDonutPropTypes } from "@/lib/types/visualizations/charts/DonutChart.types";

export default function DonutChartDonut({
  size,
  donutLabel,
  total,
}: DonutChartDonutPropTypes) {
  const l = useLocales();

  const donutStyle: React.CSSProperties = {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: size === "large" ? "0.75rem" : "0.5rem",
    height: size === "large" ? "13.5rem" : "9rem",
    width: size === "large" ? "13.5rem" : "9rem",
    alignSelf: "center",
    borderRadius: "50%",
    backgroundColor: "var(--color-background-frame)",
  };

  return (
    <div style={donutStyle}>
      <Body size="sm" fontWeight={400} lineHeight="1.5" textAlign="center">
        {l(donutLabel)}
      </Body>

      <Heading3>{FormatUtils.formatCompactNumber(total)}</Heading3>
    </div>
  );
}
